import React, { useState } from "react";
import {
  ChevronDown,
  MapPin,
  CheckCircle,
  ArrowLeft,
  ArrowRight,
} from "lucide-react";
import { constants } from "../constants";

const ContactUsForm = () => {
  const { serverURL } = constants;
  const [step, setStep] = useState(1);
  const [showSuccessModal, setShowSuccessModal] = useState(false);

  const [formData, setFormData] = useState({
    first_name: "",
    email_id: "",
    mobile_no: "",
    country_code: "+91",
    city: "",
    state: "",
    branch: "",
    country: "",
    intake_year: "",
    intake: "",
    purpose: "",
    counsellingMode: "",
    agreeToTerms: false,
    name: "",
    email: "",
    phone: "",
    nearestOffice: "",
    studyDestination: "",
    studyYear: "",
    studyIntake: "",
  });

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const branchMapping = {
    "Anand (HO)": "1",
    "Ahmedabad- Navrangpura": "2",
    "Ahmedabad- Maninagar": "3",
    Nadiad: "4",
    Vadodara: "5",
    Jamnagar: "6",
    Borsad: "7",
    Navsari: "8",
    Surat: "9",
  };

  const countryMapping = {
    Canada: "1",
    UK: "2",
    USA: "3",
    Germany: "4",
    Europe: "5",
    Australia: "6",
    "New Zealand": "7",
    Other: "8",
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    const newValue = type === "checkbox" ? checked : value;

    setFormData((prev) => {
      const updated = { ...prev, [name]: newValue };

      if (name === "first_name") updated.name = newValue;
      if (name === "email_id") updated.email = newValue;
      if (name === "mobile_no") updated.phone = newValue;
      if (name === "branch")
        updated.nearestOffice = Object.keys(branchMapping).find(
          (key) => branchMapping[key] === newValue
        ) || "";
      if (name === "country")
        updated.studyDestination = Object.keys(countryMapping).find(
          (key) => countryMapping[key] === newValue
        ) || "";
      if (name === "intake_year") updated.studyYear = newValue;
      if (name === "intake") updated.studyIntake = newValue;

      return updated;
    });
  };

  const validateStep1 = () => {
    if (
      !formData.country ||
      !formData.intake_year ||
      !formData.intake ||
      !formData.purpose ||
      !formData.counsellingMode
    ) {
      setError("Please select all study preferences to continue");
      return false;
    }
    setError("");
    return true;
  };

  const handleContinue = () => {
    if (!validateStep1()) return;
    setStep(2);
  };

  const handleBack = () => {
    setStep(1);
    setError("");
  };

  const handleSubmit = async () => {
    if (
      !formData.first_name ||
      !formData.email_id ||
      !formData.mobile_no ||
      !formData.country ||
      !formData.intake_year ||
      !formData.intake ||
      !formData.purpose ||
      !formData.counsellingMode ||
      !formData.agreeToTerms
    ) {
      setError("Please complete all required fields");
      return;
    }

    setLoading(true);
    setError("");

    const updatedFormData = {
      ...formData,
      intake_year: formData.intake_year,
      studyYear: formData.intake_year,
    };

    try {
      await fetch(`${serverURL}/api/email/sendEmail`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(updatedFormData),
      });

      const crmData = {
        first_name: updatedFormData.first_name,
        email_id: updatedFormData.email_id,
        mobile_no: updatedFormData.mobile_no,
        country_code: updatedFormData.country_code,
        city: updatedFormData.city,
        state: updatedFormData.state,
        branch: updatedFormData.branch,
        country: updatedFormData.country,
        intake_year: formData.intake_year,
        intake: updatedFormData.intake,
        purpose: updatedFormData.purpose,
        counsellingMode: updatedFormData.counsellingMode,
        source_remarks: "Website Home Page",
      };

      const crmResponse = await fetch(
        "https://crmportal.maheshsuchit.com/teqcoder-api/add-leads.php?lead_type=4&source=website",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(crmData),
        }
      );

      if (!crmResponse.ok) {
        console.warn("CRM API call failed, but continuing...");
      }

      setShowSuccessModal(true);
      if (typeof window.gtag === "function") {
        window.gtag("event", "conversion", {
          send_to: "AW-759404552/q3tmCLm87JYcEIiwjuoC",
        });
      }
      setFormData({
        first_name: "",
        email_id: "",
        mobile_no: "",
        country_code: "+91",
        city: "",
        state: "",
        branch: "",
        country: "",
        intake_year: "",
        intake: "",
        purpose: "",
        counsellingMode: "",
        agreeToTerms: false,
        name: "",
        email: "",
        phone: "",
        nearestOffice: "",
        studyDestination: "",
        studyYear: "",
        studyIntake: "",
      });
      setStep(1);
    } catch (err) {
      setError("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const getCountryName = (code) =>
    Object.keys(countryMapping).find((key) => countryMapping[key] === code) || "Select destination";

  const SuccessModal = () => (
    <div className="fixed inset-0 bg-black/30 backdrop-blur-sm z-50 flex items-center justify-center p-4">
      <div className="bg-white/90 backdrop-blur-xl rounded-2xl p-8 max-w-md w-full shadow-xl border border-gray-100/50">
        <div className="text-center">
          <div className="w-16 h-16 bg-emerald-100 rounded-xl flex items-center justify-center mx-auto mb-6">
            <CheckCircle className="w-8 h-8 text-emerald-600" />
          </div>
          <h3 className="text-xl font-semibold text-gray-900 mb-4">Thank You!</h3>
          <p className="text-sm text-gray-700 mb-8 leading-relaxed">
            Our certified counsellors will contact you within 24 hours to discuss your study plans.
          </p>
          <button
            onClick={() => setShowSuccessModal(false)}
            className="w-full bg-primary-brown text-white py-3 px-6 rounded-xl font-medium text-sm hover:bg-primary-brown/90 transition-colors"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );

  return (
    <div className="w-full max-w-6xl mx-auto p-6 lg:p-10" id="contact">
      {showSuccessModal && <SuccessModal />}

      <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12 rounded-2xl shadow-lg overflow-hidden border border-gray-100/50 bg-white/80 backdrop-blur-sm">
        
        {/* Left Panel - Subtle Support */}
        <div className="lg:col-span-5 p-8 lg:p-10 bg-gradient-to-br from-slate-900/95 to-slate-900/80 text-white">
          <div className="space-y-6">
            <h1 className="text-2xl lg:text-3xl font-semibold leading-tight">
              Speak with an Expert
            </h1>
            <p className="text-sm lg:text-base text-slate-200 leading-relaxed max-w-sm">
              Get personalized guidance from our certified counsellors. No obligation, just expert advice.
            </p>
          </div>

          <div className="space-y-4 pt-8 border-t border-slate-800/50">
            <div className="flex items-start gap-3 p-4 bg-slate-800/20 rounded-xl hover:bg-slate-800/40 transition-colors">
              <div className="w-8 h-8 bg-white/10 rounded-lg flex items-center justify-center mt-0.5 flex-shrink-0">
                <span className="text-xs font-medium">✓</span>
              </div>
              <div>
                <p className="font-medium text-sm">Free Consultation</p>
                <p className="text-xs text-slate-400">25+ years experience</p>
              </div>
            </div>
            <div className="flex items-start gap-3 p-4 bg-slate-800/20 rounded-xl hover:bg-slate-800/40 transition-colors">
              <div className="w-8 h-8 bg-white/10 rounded-lg flex items-center justify-center mt-0.5 flex-shrink-0">
                <span className="text-xs font-medium">✓</span>
              </div>
              <div>
                <p className="font-medium text-sm">No Commitment</p>
                <p className="text-xs text-slate-400">Just helpful guidance</p>
              </div>
            </div>
          </div>

          <p className="text-lg font-medium text-slate-100 opacity-90">
            Trusted by 10,000+ students
          </p>
        </div>

        {/* Form Panel */}
        <div className="lg:col-span-7 p-8 lg:p-10">
          <div className="max-w-3xl mx-auto">
            
            {/* Subtle Step Indicator */}
            <div className="flex items-center justify-center mb-10 lg:mb-14 p-4 lg:p-6 bg-gray-50/80 rounded-xl border border-gray-100 shadow-sm">
              <div className="flex items-center gap-3 lg:gap-4">
                <div className={`w-10 h-10 lg:w-12 lg:h-12 rounded-2xl flex items-center justify-center text-sm lg:text-base font-medium transition-all ${
                  step === 1 
                    ? 'bg-primary-brown text-white' 
                    : 'bg-gray-200 text-gray-600 hover:bg-gray-300'
                }`}>
                  1
                </div>
                <div className={`w-2 h-2 lg:w-3 lg:h-3 rounded-full transition-colors ${
                  step === 2 ? 'bg-primary-brown' : 'bg-gray-200'
                }`} />
                <div className={`w-10 h-10 lg:w-12 lg:h-12 rounded-2xl flex items-center justify-center text-sm lg:text-base font-medium transition-all ${
                  step === 2 
                    ? 'bg-primary-brown text-white' 
                    : 'bg-gray-200 text-gray-600 hover:bg-gray-300'
                }`}>
                  2
                </div>
              </div>
              <span className="ml-4 lg:ml-6 text-base lg:text-lg font-medium text-gray-700">
                Step {step} of 2
              </span>
            </div>

            {/* Step 1: Study Preferences */}
            {step === 1 && (
              <div className="space-y-8 lg:space-y-10">
                <div className="text-center">
                  <h2 className="text-2xl lg:text-3xl font-semibold text-gray-900 mb-4">
                    Where would you like to study?
                  </h2>
                  <p className="text-base lg:text-lg text-gray-600">
                    Just a few quick preferences
                  </p>
                </div>

                <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 lg:gap-8">
                  {/* Destination */}
                  <div className="lg:col-span-2">
                    <label className="text-sm lg:text-base font-medium text-gray-900 block mb-3">
                      Study Destination
                    </label>
                    <select
                      name="country"
                      value={formData.country}
                      onChange={handleChange}
                      className="w-full p-4 lg:p-5 text-base lg:text-lg bg-white/80 border border-gray-200 rounded-xl focus:border-primary-brown/70 focus:ring-2 focus:ring-primary-brown/10 focus:outline-none transition-all duration-200 hover:border-gray-300"
                    >
                      <option value="">Choose your destination</option>
                      <option value="1">Canada</option>
                      <option value="2">UK</option>
                      <option value="3">USA</option>
                      <option value="4">Germany</option>
                      <option value="5">Europe</option>
                      <option value="6">Australia</option>
                      <option value="7">New Zealand</option>
                      <option value="8">Other</option>
                    </select>
                  </div>

                  {/* Year + Intake */}
                  <div>
                    <label className="text-sm lg:text-base font-medium text-gray-900 block mb-3">
                      Target Year
                    </label>
                    <input
                      type="number"
                      name="intake_year"
                      value={formData.intake_year}
                      onChange={handleChange}
                      min="2026"
                      max="2030"
                      placeholder="2026"
                      className="w-full p-4 lg:p-5 text-base lg:text-lg bg-white/80 border border-gray-200 rounded-xl focus:border-primary-brown/70 focus:ring-2 focus:ring-primary-brown/10 focus:outline-none transition-all duration-200 hover:border-gray-300"
                    />
                  </div>

                  <div>
                    <label className="text-sm lg:text-base font-medium text-gray-900 block mb-3">
                      Intake Season
                    </label>
                    <select
                      name="intake"
                      value={formData.intake}
                      onChange={handleChange}
                      className="w-full p-4 lg:p-5 text-base lg:text-lg bg-white/80 border border-gray-200 rounded-xl focus:border-primary-brown/70 focus:ring-2 focus:ring-primary-brown/10 focus:outline-none transition-all duration-200 hover:border-gray-300 appearance-none"
                    >
                      <option value="">Season</option>
                      <option>Fall</option>
                      <option>Spring</option>
                      <option>Autumn</option>
                      <option>Summer</option>
                    </select>
                  </div>

                  {/* Goal */}
                  <div className="lg:col-span-2">
                    <label className="text-sm lg:text-base font-medium text-gray-900 block mb-3">
                      What brings you here?
                    </label>
                    <select
                      name="purpose"
                      value={formData.purpose}
                      onChange={handleChange}
                      className="w-full p-4 lg:p-5 text-base lg:text-lg bg-white/80 border border-gray-200 rounded-xl focus:border-primary-brown/70 focus:ring-2 focus:ring-primary-brown/10 focus:outline-none transition-all duration-200 hover:border-gray-300 appearance-none"
                    >
                      <option value="">Select your goal</option>
                      <option value="2">Student Visa</option>
                      <option value="4">Study Abroad</option>
                      <option value="1">Visitor Visa</option>
                      <option value="6">IELTS</option>
                      <option value="9">Counselling</option>
                      <option value="14">Other</option>
                    </select>
                  </div>

                  {/* Mode */}
                  <div className="lg:col-span-2">
                    <label className="text-sm lg:text-base font-medium text-gray-900 block mb-4">
                      Preferred consultation
                    </label>
                    <div className="grid grid-cols-2 gap-4">
                      <label className="p-4 border border-gray-200 rounded-lg hover:border-primary-brown/30 hover:bg-gray-50 cursor-pointer transition-all flex items-center justify-center text-base lg:text-lg font-medium">
                        <input
                          type="radio"
                          name="counsellingMode"
                          value="online"
                          checked={formData.counsellingMode === "online"}
                          onChange={handleChange}
                          className="sr-only peer"
                        />
                        <span className="peer-checked:text-primary-brown">Online</span>
                      </label>
                      <label className="p-4 border border-gray-200 rounded-lg hover:border-primary-brown/30 hover:bg-gray-50 cursor-pointer transition-all flex items-center justify-center text-base lg:text-lg font-medium">
                        <input
                          type="radio"
                          name="counsellingMode"
                          value="offline"
                          checked={formData.counsellingMode === "offline"}
                          onChange={handleChange}
                          className="sr-only peer"
                        />
                        <span className="peer-checked:text-primary-brown">In-Person</span>
                      </label>
                    </div>
                  </div>
                </div>

                {error && (
                  <div className="p-4 bg-rose-50 border border-rose-200 rounded-xl text-rose-800 text-sm">
                    {error}
                  </div>
                )}

                <button
                  onClick={handleContinue}
                  disabled={loading}
                  className="w-full lg:max-w-sm mx-auto block bg-primary-brown text-white py-4 px-8 rounded-xl font-medium text-base lg:text-lg hover:bg-primary-brown/90 focus:outline-none focus:ring-2 focus:ring-primary-brown/20 transition-all duration-200 shadow-lg hover:shadow-xl"
                >
                  Continue
                </button>
              </div>
            )}

            {/* Step 2: Contact Details */}
            {step === 2 && (
              <div className="space-y-10 lg:space-y-12">
                <div className="text-center">
                  <h2 className="text-2xl lg:text-3xl font-semibold text-gray-900 mb-4">
                    Let's connect
                  </h2>
                  <p className="text-base lg:text-lg text-gray-600 max-w-md mx-auto">
                    {getCountryName(formData.country)} • {formData.intake} {formData.intake_year}
                  </p>
                </div>

                {/* Minimal Summary */}
                <div className="grid grid-cols-2 gap-6 p-6 lg:p-8 bg-gray-50/50 rounded-xl border border-gray-100">
                  <div className="text-center">
                    <div className="text-xl lg:text-2xl font-medium text-gray-900 mb-1">
                      {getCountryName(formData.country)}
                    </div>
                    <div className="text-xs text-gray-500 uppercase tracking-wide font-medium">
                      Destination
                    </div>
                  </div>
                  <div className="text-center">
                    <div className="text-xl lg:text-2xl font-medium text-gray-900 mb-1">
                      {formData.intake} {formData.intake_year}
                    </div>
                    <div className="text-xs text-gray-500 uppercase tracking-wide font-medium">
                      Intake
                    </div>
                  </div>
                </div>

                <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 lg:gap-8">
                  {/* Contact */}
                  <div className="space-y-6 lg:space-y-8">
                    <div>
                      <label className="text-sm lg:text-base font-medium text-gray-900 block mb-3">
                        Full Name *
                      </label>
                      <input
                        type="text"
                        name="first_name"
                        value={formData.first_name}
                        onChange={handleChange}
                        placeholder="Enter your name"
                        className="w-full p-4 lg:p-5 text-base lg:text-lg bg-white/80 border border-gray-200 rounded-xl focus:border-primary-brown/70 focus:ring-2 focus:ring-primary-brown/10 focus:outline-none transition-all duration-200 hover:border-gray-300"
                        required
                      />
                    </div>

                    <div>
                      <label className="text-sm lg:text-base font-medium text-gray-900 block mb-3">
                        Email *
                      </label>
                      <input
                        type="email"
                        name="email_id"
                        value={formData.email_id}
                        onChange={handleChange}
                        placeholder="your@email.com"
                        className="w-full p-4 lg:p-5 text-base lg:text-lg bg-white/80 border border-gray-200 rounded-xl focus:border-primary-brown/70 focus:ring-2 focus:ring-primary-brown/10 focus:outline-none transition-all duration-200 hover:border-gray-300"
                        required
                      />
                    </div>
                  </div>

                  {/* Phone + Location */}
                  <div className="space-y-6 lg:space-y-8">
                    <div>
                      <label className="text-sm lg:text-base font-medium text-gray-900 block mb-3">
                        Phone *
                      </label>
                      <div className="flex gap-3 p-1 bg-white/50 rounded-xl border border-gray-200">
                        <select
                          name="country_code"
                          value={formData.country_code}
                          onChange={handleChange}
                          className="w-24 p-3 lg:p-4 bg-white border-0 rounded-lg font-medium text-base lg:text-lg focus:outline-none"
                        >
                          <option value="+91">+91</option>
                        </select>
                        <input
                          type="tel"
                          name="mobile_no"
                          value={formData.mobile_no}
                          onChange={handleChange}
                          placeholder="XXXXXXXXXX"
                          className="flex-1 p-3 lg:p-4 text-base lg:text-lg border-0 bg-white rounded-lg focus:outline-none"
                          required
                        />
                      </div>
                    </div>

                    {/* Optional Location */}
                    <details className="group">
                      <summary className="flex items-center gap-2 p-4 border border-gray-200 rounded-xl hover:border-gray-300 hover:bg-gray-50 cursor-pointer transition-all font-medium text-sm lg:text-base group-open:bg-primary-brown/5 group-open:border-primary-brown/30">
                        <MapPin className="w-4 h-4 lg:w-5 lg:h-5 flex-shrink-0" />
                        <span>Location details (optional)</span>
                        <ChevronDown className="w-4 h-4 ml-auto transition-transform group-open:rotate-180" />
                      </summary>
                      <div className="p-6 bg-white/80 border-t border-gray-100 grid grid-cols-2 gap-3 pt-4 -mt-px rounded-b-xl">
                        <input
                          name="city"
                          value={formData.city}
                          onChange={handleChange}
                          placeholder="City"
                          className="p-3 border border-gray-200 rounded-lg focus:border-primary-brown/70 focus:ring-1 text-sm lg:text-base"
                        />
                        <input
                          name="state"
                          value={formData.state}
                          onChange={handleChange}
                          placeholder="State"
                          className="p-3 border border-gray-200 rounded-lg focus:border-primary-brown/70 focus:ring-1 text-sm lg:text-base"
                        />
                        <select
                          name="branch"
                          value={formData.branch}
                          onChange={handleChange}
                          className="p-3 border border-gray-200 rounded-lg focus:border-primary-brown/70 focus:ring-1 text-sm lg:text-base col-span-2 appearance-none"
                        >
                          <option value="">Nearest Branch</option>
                          <option value="1">Anand (HO)</option>
                          <option value="2">Ahmedabad Navrangpura</option>
                          <option value="3">Ahmedabad Maninagar</option>
                          <option value="4">Nadiad</option>
                          <option value="5">Vadodara</option>
                          <option value="6">Jamnagar</option>
                          <option value="7">Borsad</option>
                          <option value="8">Navsari</option>
                          <option value="9">Surat</option>
                        </select>
                      </div>
                    </details>
                  </div>
                </div>

                {/* Terms */}
                <label className="flex items-start gap-4 p-5 border border-gray-200 rounded-xl cursor-pointer hover:border-gray-300 hover:bg-gray-50 transition-all col-span-full">
                  <input
                    type="checkbox"
                    name="agreeToTerms"
                    checked={formData.agreeToTerms}
                    onChange={handleChange}
                    required
                    className="mt-1 w-5 h-5 text-primary-brown border-2 border-gray-300 rounded focus:ring-primary-brown mt-0.5 flex-shrink-0"
                  />
                  <span className="text-sm lg:text-base leading-relaxed text-gray-700">
                    I agree to the{' '}
                    <a href="#privacy-policy" className="text-primary-brown font-medium hover:underline">
                      Privacy Policy
                    </a>{' '}
                    and{' '}
                    <a href="#terms-conditions" className="text-primary-brown font-medium hover:underline">
                      Terms
                    </a>
                  </span>
                </label>

                {error && (
                  <div className="p-4 bg-rose-50 border border-rose-200 rounded-xl text-rose-800 text-sm col-span-full">
                    {error}
                  </div>
                )}

                {/* Actions */}
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 pt-8 col-span-full">
                  <button
                    onClick={handleBack}
                    className="h-12 lg:h-14 bg-white border border-gray-200 text-gray-700 py-3 px-6 rounded-xl font-medium hover:bg-gray-50 hover:border-gray-300 focus:outline-none focus:ring-2 focus:ring-gray-200 transition-all flex items-center justify-center"
                  >
                    <ArrowLeft className="w-4 h-4 mr-2" />
                    Back
                  </button>
                  <button
                    onClick={handleSubmit}
                    disabled={loading}
                    className="h-12 lg:h-14 bg-primary-brown text-white py-3 px-6 rounded-xl font-medium hover:bg-primary-brown/90 focus:outline-none focus:ring-2 focus:ring-primary-brown/20 transition-all shadow-lg hover:shadow-xl flex items-center justify-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed"
                  >
                    {loading ? (
                      <>
                        <div className="w-4 h-4 border-2 border-white/30 border-t-white rounded-full animate-spin" />
                        Sending...
                      </>
                    ) : (
                      <>
                        Speak with Expert
                        <ArrowRight className="w-4 h-4" />
                      </>
                    )}
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactUsForm;
